export default __webpack_public_path__ + "static/media/work-item-alt2.f2de979f.svg";